<template>
    <ul
        id="main-menu-navigation"
        class="nav navbar-nav"
        style="place-content: center"
    >
        <li
            class="nav-item align-self-center"
            v-if="position > 0"
            @click="position--"
        >
            <font-awesome-icon
                icon="circle-chevron-left"
                size="sm"
            />
        </li>
        <component
            :is="resolveNavComponent(item)"
            v-for="item in items.slice(start(), end())"
            :key="item.header || item.title"
            :item="item"
        />
        <li
            class="nav-item align-self-center"
            @click="position++"
            v-if="items.length > end()"
        >
            <font-awesome-icon
                icon="circle-chevron-right"
                size="sm"
            />
        </li>
    </ul>
</template>

<script>
import HorizontalNavMenuHeaderGroup from '../horizontal-nav-menu-header-group/HorizontalNavMenuHeaderGroup.vue'
import HorizontalNavMenuHeaderLink from '../horizontal-nav-menu-header-link/HorizontalNavMenuHeaderLink.vue'
import { useWindowSize } from '@vueuse/core'

export default {
    components: {
        HorizontalNavMenuHeaderLink,
        HorizontalNavMenuHeaderGroup,
    },
    props: {
        items: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            position: 0,
        }
    },
    methods: {
        start() {
            if (this.position === 0) {
                return 0
            } else {
                return this.itemSlice() * this.position
            }
        },
        end() {
            if (this.position === 0) {
                return this.itemSlice()
            } else {
                return this.itemSlice() * this.position + this.itemSlice()
            }
        },
        itemSlice() {
            const { width } = useWindowSize()
            if (width.value >= 1920) {
                return 20
            }
            if (width.value >= 1768 && width.value < 1920) {
                return 18
            }
            if (width.value >= 1600 && width.value < 1768) {
                return 16
            }
            if (width.value >= 1440 && width.value < 1600) {
                return 14
            }
            if (width.value >= 1280 && width.value < 1440) {
                return 12
            }
            return 10
        },
    },
    setup() {
        const resolveNavComponent = item => {
            if (item.children) return 'horizontal-nav-menu-header-group'
            return 'horizontal-nav-menu-header-link'
        }

        return {
            resolveNavComponent,
        }
    },
}
</script>
